module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.loading == true) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Details"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.popupStatus.length > 0) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Updated Status")]) : _vm._e(), _vm._v(" "), (_vm.popupStatus.length > 0) ? _c('v-select', {
    staticClass: "colorSelect",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "items": _vm.popupStatus,
      "label": "Select Status",
      "item-value": "text",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckUpdate
    },
    model: {
      value: (_vm.newStatus),
      callback: function($$v) {
        _vm.newStatus = $$v
      },
      expression: "newStatus"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Reason for Status Change")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "3",
      "multi-line": "",
      "clearable": "",
      "label": "Enter your reason here",
      "solo": ""
    },
    model: {
      value: (_vm.additionalComments),
      callback: function($$v) {
        _vm.additionalComments = $$v
      },
      expression: "additionalComments"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.popupStatus.length > 0) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": !_vm.canUpdate,
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateReportStatus()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (_vm.popupStatus.length == 0) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateReportStatus()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}